import { FC } from 'react';
import { Link, Typography } from 'melp-design/components';
import { useTranslation } from 'react-i18next';
import { MASKED_EMPLOYEE_PLACEHOLDER } from 'store/employees';
import { ROUTES } from 'config';

interface Props {
  employee: {
    id: string;
    fullName: string;
  } | null;
  to?: string;
  fallback?: string;
}

export const EmployeeCell: FC<Props> = ({ employee, to, fallback }) => {
  const { t } = useTranslation();

  if (!employee) {
    return (
      <Typography variant="p1" color="textSecondary">
        {fallback ?? t('marketplace.employeeDeleted')}
      </Typography>
    );
  }

  if (employee.id === MASKED_EMPLOYEE_PLACEHOLDER) {
    return (
      <Typography variant="p1" color="textSecondary">
        {MASKED_EMPLOYEE_PLACEHOLDER}
      </Typography>
    );
  }

  return (
    <Link
      label={employee.fullName}
      to={to ?? ROUTES.employees.details.replace(':id', employee.id)}
    />
  );
};
